export default "__VITE_ASSET__BGi$Fs8Z__"